<script lang="ts">
	import { page } from '$app/state';
	import { getTenantContext } from 'src/contexts/tenant.context.svelte';
	import type { TenantFeatureFlags } from 'src/types/tenant';
	import type { Snippet } from 'svelte';

	interface Props {
		children: Snippet;
		featureFlag?: keyof TenantFeatureFlags;
	}
	let { children, featureFlag }: Props = $props();

	const tenantCtx = getTenantContext();

	const shouldRender = $derived.by(() => {
		const tenant = tenantCtx?.tenant || page.data.tenant;
		return !!tenant?.feature_flags?.[featureFlag]?.enabled;
	});
</script>

{#if shouldRender}{@render children?.()}{/if}
